.root {
  /* --theme-color: #f0f; */
  /* --secondary-color: #0f0; */

  border-color: var(--theme-color, transparent);

  & [data-part='title'] {
    color: var(--secondary-color);
  }

  & [data-part='heading'] {
    color: var(--theme-color);
  }
}
